import { Link } from "react-router-dom"
import footer_logo from "../../assets/img/footer_logo.svg"
import { useEffect, useState } from "react"

export const AdminFooter = () => {
    const [currentYear, setCurrentYear] = useState();

    useEffect(() => {
        setCurrentYear(new Date().getFullYear());
    }, []);
    return (
        <>
            <footer class="site_footer">
                <div class="top_part">
                    <div class="site_container">
                       
                    </div>
                </div>
                <div class="bottom_part">
                    <div class="site_container">
                        <div class="site_row">
                            <p>© {currentYear}. All rights reserved.</p>
                           
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}